// extracted by mini-css-extract-plugin
export default {"twitterCard":"TwitterSearchSourceCard_twitterCard__db-5Y"};